@if (loading) {
  <app-admin-state-panel
    mode="loading"
    titleKey="COMMON.LOADING"
    descriptionKey="ADMIN.ROLES.DETAIL.LOADING"
  ></app-admin-state-panel>
} @else if (hasError || !role) {
  <app-admin-state-panel
    mode="error"
    titleKey="COMMON.ERROR"
    descriptionKey="ADMIN.ROLES.DETAIL.ERROR"
    [showRetry]="true"
    (retry)="load()"
  ></app-admin-state-panel>
} @else {
  <app-admin-form-layout
    titleKey="ADMIN.ROLES.DETAIL.PERMISSIONS_TITLE"
    descriptionKey="ADMIN.ROLES.DETAIL.PERMISSIONS_DESCRIPTION"
  >
    <app-form-role-permissions [payload]="role"></app-form-role-permissions>
  </app-admin-form-layout>
}

